import instance from '@/services/instance'
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { userLayoutService } from '@/bundles/Settings/factories/userLayoutServiceFactory';
import { memberOldService } from '@/bundles/Members/factory/memberOldServiceFactory';

import * as actionTypes from './settings-actions-types';
import * as constants from './settings-types'

const errorMapper = new ErrorMapper();

export default {
  async [constants.UPDATE_PAGE_LAYOUT] ({ commit }, { widgets, page }) {
    try {
      const response = await userLayoutService.updateLayoutSettings({ widgets, page });

      commit(constants.SET_LAYOUT_SETTINGS, { value: response, page });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  async [constants.INITIALIZE_PAGE_LAYOUT] ({ commit }, { widgets, page }) {
    try {
      const response = await userLayoutService.initializeLayoutSettings({ widgets, page });

      commit(constants.SET_LAYOUT_SETTINGS, { value: response, page });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  async [constants.GET_LAYOUT_SETTINGS] ({ commit }, { page }) {
    try {
      const response = await userLayoutService.getLayoutSettings(page);

      commit(constants.SET_LAYOUT_SETTINGS, { value: response, page });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  [constants.SEND_FEEDBACK] ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      instance
        .post('/request', payload, {
          headers: {
            Authorization: 'Bearer ' + rootState.idToken,
          },
        })
        .then(() => {
          resolve(true)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    })
  },
  [constants.GET_ALL_PERMISSIONS] ({ rootState, commit }, id) {
    return new Promise((resolve, reject) => {
      instance
        .get(`/member/${id}`, {
          headers: {
            Authorization: 'Bearer ' + rootState.idToken,
          },
        })
        .then((response) => {
          let { permissions } = response.data[0]
          let payload = {}
          permissions.forEach((item) => {
            payload = Object.assign(payload, item)
          })
          commit(constants.SET_ALL_PERMISSIONS, payload)
          resolve(payload)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    })
  },
  async [actionTypes.GET_USER_SETTINGS] ({ rootState, commit }, id) {
    const { data: response } = await instance.get(`/member-settings/${ id }`, {
      headers: {
        Authorization: 'Bearer ' + rootState.idToken,
      },
    });
    commit(constants.SET_SETTINGS_KEY, response._key);
    commit(constants.SET_ALL_PERMISSIONS, response.permissions);
    commit(constants.SET_DEVICE_TOKENS, response.device_tokens);
    commit(constants.SET_USER_NOTIFICATION_SETTINGS, response.notifications);
    commit(constants.SET_USER_OPEX_DISPLAY, response.opex_display);
    commit(constants.SET_FOCUS_AREA_KEY, response.focus_area?._key);
    commit(constants.SET_FOCUS_AREA, response.focus_area);
    commit(constants.SET_USER_VISUALIZATION_SETTINGS, response.visualization_settings);
    commit(constants.SET_AI_KEYS, response.ai_credentials);
    commit(constants.SET_RECORD_PERMISSIONS, response.record_permissions);
    if (response.custom_fields) {
      commit(constants.SET_CUSTOM_FIELDS, response.custom_fields);
    }
  },
  async [actionTypes.UPDATE_USER_NOTIFICATIONS_SETTINGS] ({ commit }, { id, data }) {
    const response = await memberOldService.updateMemberNotificationsSettings(id, data)
    commit(constants.SET_USER_NOTIFICATION_SETTINGS, response);
  },
  async [actionTypes.UPDATE_USER_OPEX_DISPLAY] ({ commit }, { id, data }) {
    const response = await memberOldService.updateMemberOpexDisplaySettings(id, data)
    commit(constants.SET_USER_OPEX_DISPLAY, response);
  },
  async [actionTypes.UPDATE_RECORD_PERMISSIONS] ({ commit }, { id, data }) {
    const response = await memberOldService.updateMemberRecordPermissions(id, data)
    commit(constants.SET_RECORD_PERMISSIONS, response);
  },
}
